import React, { useEffect, useRef, useState } from "react";
import './TablaBitacoras.scss'
import InputCalendario from "../../atoms/InputCalendario/InputCalendario";
// import useGetHora from "../../../CustomHooks/useGetHora";
import { convertirFormatoFecha, formateoBasico, isoAUtc } from "../../../utilities/formateos";
import InputLista from "../../atoms/InputLista/InputLista";
import TextArea from "../../atoms/TextArea/TextArea";
import ButtonGris from "../../atoms/ButtonGris/ButtonGris";
import Button from "../../atoms/Button/Button";
import { getCausa, getEfectos, getIncidente, resistrarIncidente, updateIncidente } from "./TablaBitacorasntegracion";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import lapiz from '../../../assets/icons/lapiz.png'
const keytoken = process.env.REACT_APP_CLAVE_INCRIPTACION;
const ModalRegistrarIncidente = ({ data, setShowCrearIncidente }) => {
    const [fecha, setFecha] = useState(formateoBasico(new Date()))
    const [causas, setCausas] = useState([])
    const [causa, setCausa] = useState(null)
    const [efectos, setEfectos] = useState([])
    const [efecto, setEfecto] = useState(null)
    const [afectoServicioCheck, setAfectoServicioCheck] = useState(false)
    const [responsabilidadSumaCheck, setResponsabilidadSumaCheck] = useState(true)
    const [facturaCheck, setFacturaCheck] = useState(false)
    const [detalle, setDetalle] = useState(null)
    const [notaFacturacion, setNotaFacturacion] = useState(null)
    const [incidenteData, setIncidenteData] = useState(null)
    const [editarIncidente, setEditarIncidente] = useState(null)
    useEffect(() => {
        getCausa(setCausas, "bitacoras")
        const getIncidentesAsync = async () => {
            await getIncidente(setIncidenteData, data.bitacora)
        }
        getIncidentesAsync()

    }, [])
    useEffect(() => {
        if (causa) {
            getEfectos(setEfectos, causa.code)
        }
    }, [causa])
    // useEffect(() => {
    //     if (incidenteData) {
    //         setFecha(isoAUtc(incidenteData.fecha))
    //         setEfecto({ name: incidenteData.EFECTO_NOMBRE, code: incidenteData.ID_EFECTO })
    //         setCausa({ name: incidenteData.CAUSA_NOMBRE, code: incidenteData.ID_CAUSA })
    //         setAfectoServicioCheck(incidenteData.AFECTO_SERVICIO)
    //         setResponsabilidadSumaCheck(incidenteData.RESPONSABILIDAD_SUMA)
    //         setDetalle(incidenteData.DETALLE)
    //         setNotaFacturacion(incidenteData.NOTA_FACTURACION)

    //     }
    // }, [incidenteData])
    const edit = async () => {
        if (causa && efecto && detalle) {
            // ID_CAUSA,
            // DETALLE,
            // ID_EFECTO,
            // FACTURAR,
            // FECHA,
            // ID_UNIDAD,
            // NOTA_FACTURACION,
            // RESPONSABILIDAD_SUMA,
            // USUARIO
            const token = sessionStorage.getItem("token")
            const dataUser = jwtDecode(token, keytoken)
            const dataRegistrarIncidente = {
                id_incidente: editarIncidente.ID,
                id_causa: causa.code,
                detalle: detalle,
                id_efecto: efecto.code,
                facturar: facturaCheck === true ? '1' : facturaCheck === false ? '0' : null,
                fecha: isoAUtc(data.fecha) + ' ' + '00:00:00',
                id_unidad: data.id_unidad,
                nota_facturacion: notaFacturacion,
                responsabilidad_suma: causa.RESPONSABILIDAD_SUMA === true ? '1' : causa.RESPONSABILIDAD_SUMA === false ? '0' : null,
                id_usuario: dataUser.ID,//usuario quien hace la transferencia 
                tipo: causa.TIPO,
                afecto_servicio: causa.AFECTA_SERVICIO === true ? '1' : causa.AFECTA_SERVICIO === false ? '0' : null,//usuario quien hace la transferencia 
                id_bitacora: data.bitacora,
                // tipoReembolso:tipoReembolso,
                usuario_incidente: "Incidencia hecha por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE
            }
            const editIncidente = async () => {

                await updateIncidente(dataRegistrarIncidente, setEditarIncidente, limpiar)
            }
            await editIncidente()
            await getIncidente(setIncidenteData, data.bitacora)
        }
    }
    const submit = async () => {
        if (causa && efecto && detalle) {
            // ID_CAUSA,
            // DETALLE,
            // ID_EFECTO,
            // FACTURAR,
            // FECHA,
            // ID_UNIDAD,
            // NOTA_FACTURACION,
            // RESPONSABILIDAD_SUMA,
            // USUARIO
            const token = sessionStorage.getItem("token")
            const dataUser = jwtDecode(token, keytoken)
            const dataRegistrarIncidente = {

                id_causa: causa.code,
                detalle: detalle,
                id_efecto: efecto.code,
                facturar: facturaCheck === true ? '1' : facturaCheck === false ? '0' : null,
                fecha: isoAUtc(data.fecha) + ' ' + '00:00:00',
                id_unidad: data.id_unidad,
                nota_facturacion: notaFacturacion,
                responsabilidad_suma: causa.RESPONSABILIDAD_SUMA === true ? '1' : causa.RESPONSABILIDAD_SUMA === false ? '0' : null,
                id_usuario: dataUser.ID,//usuario quien hace la transferencia 
                tipo: causa.TIPO,
                afecto_servicio: causa.AFECTA_SERVICIO === true ? '1' : causa.AFECTA_SERVICIO === false ? '0' : null,//usuario quien hace la transferencia 
                id_bitacora: data.bitacora,
                // tipoReembolso:tipoReembolso,
                usuario_incidente: "Incidencia hecha por :" + jwtDecode(sessionStorage.getItem("token")).NOMBRE
            }
            const addIncidente = async () => {
                Swal.fire({ title: 'Guardando...', allowOutsideClick: false, allowEscapeKey: false, didOpen: () => Swal.showLoading() });
                return await resistrarIncidente(dataRegistrarIncidente, setShowCrearIncidente, limpiar)
            }
            const ok = await addIncidente()
            if (ok) await getIncidente(setIncidenteData, data.bitacora)
        }
        else {
            Swal.fire({
                icon: 'error',   // Icono de error
                title: 'Oops...', // Título de la alerta
                text: 'Rellena todos los campos obligatorios', // Mensaje de error
                confirmButtonText: 'OK'  // Texto del botón de confirmación
            });
        }
    }
    const limpiar = () => {
        setCausa()
        setEfecto()
        setDetalle("")
    }
    const formatoFecha = (rowData) => {
        return (
            <td data-label="FECHA">{convertirFormatoFecha(isoAUtc(rowData.FECHA))}</td>
        )
    }
    const editarIncidenteTemplate = (rowData) => {
        return (
            <Button onClick={() => { llenar(rowData) }}>
                <img style={{ width: "20px" }} src={lapiz} alt="" />
            </Button>
        )
    }
    const llenar = (rowData) => {

        setCausa({ code: rowData.ID_CAUSA, name: rowData.CAUSA_NOMBRE })
        setEfecto({ code: rowData.ID_EFECTO, name: rowData.EFECTO_NOMBRE })
        setDetalle(rowData.DETALLE)
        setEditarIncidente(rowData)
    }


    return (
        <>
            <Dialog header={() => { return (<>ASUNTO : {data?.ASUNTO ? data?.ASUNTO : "Sin asunto"}</>) }} visible={data} className="modalDialog" onClick={(e) => { e.stopPropagation(); }} onHide={() => { setShowCrearIncidente(false) }} >
                <div className="modalRegistrarIncidente">
                    <div className="titleN">Registrar incidente en bitácora : {data.bitacora}</div>
                    <div className="containerInfo">
                        <div className="titleN">{data.ruta}</div>
                        <div className="titleN">{data.nombre}</div>
                    </div>

                    <div className="margen">
                        <div className="conainerFecha">
                        </div>
                        <div className="containerCEDN">
                            <div className="cont">
                                <InputLista placeholder={causa?.name} options={causas} value={causa} onChange={(e) => { setCausa(e.value); setEfecto(null) }} titulo={"Causa"}></InputLista>
                                <TextArea onChange={(e) => { setDetalle(e.target.value) }} value={detalle} titulo={"Detalle"} className={"textAreaClass"}></TextArea>
                            </div>
                            <div className="cont">
                                <InputLista options={efectos} value={efecto} onChange={(e) => { setEfecto(e.value) }} titulo={"Efecto"}></InputLista>
                            </div>

                        </div>
                        <div className="containerButtons">
                            <ButtonGris onClick={() => { setShowCrearIncidente(null) }}>Cancelar</ButtonGris>
                            <Button onClick={() => { submit() }}>{incidenteData ? "Actualizar" : "Registrar"}</Button>
                        </div>
                    </div>
                    <div className="listaIncidentes">
                        {
                            incidenteData ?
                                <DataTable
                                    // ref={dt}
                                    value={incidenteData}
                                    emptyMessage="No se encontraron resultados."

                                >
                                    <Column
                                        header="ID"
                                        field="ID"
                                    />
                                    <Column
                                        header="Fecha"
                                        field="FECHA"
                                        body={formatoFecha}
                                    />
                                    <Column
                                        header="Causa"
                                        field="CAUSA_NOMBRE"

                                    />
                                    <Column
                                        header="Efecto"
                                        field="EFECTO_NOMBRE"

                                    />
                                    <Column
                                        field="DETALLE"
                                        header={'DETALLE'}
                                    />
                                    <Column
                                        header='Editar'
                                        body={editarIncidenteTemplate}
                                    />
                                    {/* <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} body={statusBodyTemplate} filter filterElement={statusRowFilterTemplate} /> */}
                                </DataTable>
                                : ""
                        }
                    </div>
                </div>
            </Dialog>
            <Dialog header={() => { return (<>Editar incidente #({editarIncidente?.ID})</>) }} visible={editarIncidente} className="modalDialog" onClick={(e) => { e.stopPropagation(); }} onHide={() => { setEditarIncidente(null) }} >
                <div className="modalRegistrarIncidente">
                    <div className="margen">
                        <div className="conainerFecha">
                        </div>
                        <div className="containerCEDN">
                            <div className="cont">
                                <InputLista placeholder={causa?.name} options={causas} value={causa} onChange={(e) => { setCausa(e.value); setEfecto(null) }} titulo={"Causa"}></InputLista>
                                <TextArea onChange={(e) => { setDetalle(e.target.value) }} value={detalle} titulo={"Detalle"} className={"textAreaClass"}></TextArea>
                            </div>
                            <div className="cont">
                                <InputLista options={efectos} value={efecto} onChange={(e) => { setEfecto(e.value) }} titulo={"Efecto"}></InputLista>
                            </div>

                        </div>
                        <div className="containerButtons">
                            <ButtonGris onClick={() => { setShowCrearIncidente(null) }}>Cancelar</ButtonGris>
                            <Button onClick={() => { edit() }}>{incidenteData ? "Actualizar" : "Registrar"}</Button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
export default ModalRegistrarIncidente